import { NavigationTreeMapping, NavigationTreeNode } from '@wpp-open/core'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigationTreeNestedNodesApi } from 'api/navigation/queries/useNavigationTreeNestedNodesApi'
import { NavigationDefaults } from 'constants/navigation'
import { useProviderNoncriticalError } from 'hooks/useProviderNoncriticalError'
import { useCurrentTenantData } from 'providers/currentTenantData/CurrentTenantDataContext'

export const useNavigationTreeSubLevels = (parentId: string, isEnabled: boolean) => {
  const { t } = useTranslation()
  const { currentTenant, navigationTreeWithHiddenLevel, addNodesToTree } = useCurrentTenantData()
  const {
    isLoading: isNavigationTreeLoading,
    data: navigationTreeSubLevels,
    isError: isNavigationTreeError,
  } = useNavigationTreeNestedNodesApi({
    params: {
      tenantId: currentTenant.id,
      parentId,
    },
    enabled: isEnabled,
    staleTime: NavigationDefaults.StaleTime,
    gcTime: NavigationDefaults.GcTime,
  })

  useProviderNoncriticalError({
    isError: isNavigationTreeError,
    message: t('os.provider_errors.navigation_tree'),
  })

  useEffect(() => {
    if (navigationTreeSubLevels?.mapping && Object.keys(navigationTreeSubLevels?.mapping).length) {
      const parentNode = navigationTreeWithHiddenLevel.mapping[parentId] as NavigationTreeNode
      parentNode.children = Object.keys(navigationTreeSubLevels.mapping)
      addNodesToTree({
        ...navigationTreeWithHiddenLevel,
        mapping: {
          ...navigationTreeSubLevels.mapping,
          ...navigationTreeWithHiddenLevel.mapping,
          ...({ [parentId]: parentNode } as NavigationTreeMapping),
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigationTreeSubLevels])

  return { isNavigationTreeLoading }
}
